<template>
    <div ref="twoy" class="container"></div>
</template>

<script>
import echarts from 'echarts';
import {chartMerge} from 'echarts-config';
import {twoyData} from '@/runtime-components/data';

export default {
    name: 'de-bars',
    props: {
        data: {
            type: Object,
            default: () => {
                return twoyData;
            }
        },
        rotate: {
            type: Number,
            default: 0
        },
        legend: {
            type: String,
            default: '蒸发量,降水量,平均温度'
        },
        yIndex: {
            type: String,
            default: '0,0,1'
        },
        leftYUnit: {
            type: String,
            default: 'ml'
        },
        rightYUnit: {
            type: String,
            default: '°C'
        }
    },
    data() {
        let chartIns = {
            chart: null,
            option: []
        };
        return {
            getChart() {
                return chartIns;
            }
        }
    },
    mounted() {
        this.initChart();
    },
    destroyed(){
        this.destroyChart();
    },
    watch: {
        rotate(v) {
            let chart = this.getChart().chart;
            chart && (chart.setOption({
                xAxis: [{
                    type: 'category',
                    axisLabel: {
                        rotate: v
                    }
                }]
            }));
        },
        yIndex(v) {
            let chart = this.getChart().chart;
            let legend = this.legend.split(',');
            let series = this.dealData(this.data);
            chart && (chart.setOption({
                legend: {
                    data: legend
                }
            }));
            let option = chart.getOption();
            option.series = series;
            chart.setOption(option, true);
        },
        leftYUnit(v) {
            let _this = this;
            let chart = this.getChart().chart;
            chart && (chart.setOption({
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: function (value, index) {
                                return `${value} ${v}`;
                            }
                        }
                    },
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: function (value, index) {
                                return `${value} ${_this.rightYUnit}`;
                            }
                        }
                    }
                ]
            }));
        },
        rightYUnit(v) {
            let _this = this;
            let chart = this.getChart().chart;
            chart && (chart.setOption({
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: function (value, index) {
                                return `${value} ${_this.leftYUnit}`;
                            }
                        }
                    },
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: function (value, index) {
                                return `${value} ${v}`;
                            }
                        }
                    }
                ]
            }));
        },
        legend(v) {
            let chart = this.getChart().chart;
            let legend = v.split(',');
            let series = this.dealData(this.data);
            chart && (chart.setOption({
                legend: {
                    data: legend
                }
            }));
            let option = chart.getOption();
            option.series = series;
            chart.setOption(option, true);
        },
        data: {
            handler(v) {
                if (v) {
                    let chart = this.getChart().chart;
                    let series = this.dealData(v);
                    chart && (chart.setOption({
                        xAxis: {
                            data: v.xData
                        }
                    }));
                    let option = chart.getOption();
                    option.series = series;
                    chart.setOption(option, true);
                }
            },
            deep: true
        }
    },
    methods: {
        initChart(type) {
            let _this = this;
            let chartIns = this.getChart();
            window._CHART_THEMETYPE_ = type || 'dark';
            let legend = this.legend.split(',');
            let series = this.dealData(this.data);
            //echarts
            const chart = chartMerge(
                {
                    chartType: 'lineBar'
                }, {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    legend: {
                        data: legend
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.data.xData,
                            axisPointer: {
                                type: 'shadow'
                            },
                            axisLabel: {
                                rotate: this.rotate
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            axisLabel: {
                                formatter: function (value, index) {
                                    return `${value} ${_this.leftYUnit}`;
                                }
                            }
                        },
                        {
                            type: 'value',
                            axisLabel: {
                                formatter: function (value, index) {
                                    return `${value} ${_this.rightYUnit}`;
                                }
                            }
                        }
                    ],
                    series: series
                });
            if (!chartIns.chart) {
                chartIns.chart = echarts.init(this.$refs['twoy']);
                chartIns.chart.setOption(chart);
                this.resizeChart = chartIns.chart.resize;
            }
        },
        dealData(v) {
            if (v) {
                let {data} = v;
                let bar = data.bar.concat([]);
                let line = data.line.concat([]);
                let arr = [];
                let legend = this.legend.split(',');
                let yIndex = this.yIndex.split(',');
                bar.length && (bar = bar.map((item, index)=>{
                    arr.push({
                        name: legend[index],
                        type: 'bar',
                        data: item,
                        yAxisIndex: yIndex[index]
                    });
                }));
                line.length && (line = line.map((item, index)=>{
                    arr.push({
                        name: legend[bar.length+index],
                        type: 'line',
                        data: item,
                        yAxisIndex: yIndex[bar.length+index]
                    });
                }));
                return arr;
            }
        },
        destroyChart() {
            const chartIns = this.getChart();
            if(chartIns.chart){
               chartIns.chart.dispose();
               chartIns.chart = null;
            }
        }
    }
}
</script>

<style lang="less">
@import url('~@/runtime-components/assets/common.css');
</style>